import { combineReducers } from "redux";
import userReducer from "./UserReducer";
import { forgotreducer } from "./authReducer";
import { authReducer } from "./authReducer";
import { facilityReducer } from "./dbreducers/facilityReducer";
import { payoutReducer } from "./dbreducers/payoutReducer";
import { Refreducer } from "./dbreducers/Refreducer";
import { cityReducers } from "./dbreducers/cityReducers";
import { profilereducer } from "./dbreducers/profilereducer";
import { changePasswordreducer } from "./changePasswordreducer";
import { ServiceReducers } from "./dbreducers/ServiceReducers";
import { bankDetailreducers } from "./dbreducers/bankDetailreducers";
import CalenderReducer from "./dbreducers/CalenderReducer";
import ExploreReducer from "./dbreducers/ExploreReducer";
import { patientReducer } from "./dbreducers/patientReducer";
import { chatReducers } from "./dbreducers/chatReducers";
import { orderReducer } from "./dbreducers/orderReducer";
import { feesReducer } from "./dbreducers/feesReducer";
import { usersReducer } from "./dbreducers/usersReducer";
import { productReducer } from "./dbreducers/cartReducer";
import { walletReducer } from "./dbreducers/walletReducer";

const rootReducers = combineReducers({
  UserNew: userReducer,
  auth: authReducer,
  forgotPaswword: forgotreducer,
  facilitylist: facilityReducer,
  payoutlist: payoutReducer,
  refstypes: Refreducer,
  cities: cityReducers,
  profileReducer: profilereducer,
  serviceList: ServiceReducers,
  changepassword: changePasswordreducer,
  bankReducer: bankDetailreducers,
  intervalReducer: CalenderReducer,
  exploreReducer: ExploreReducer,
  patients: patientReducer,
  chats: chatReducers,
  orderlist: orderReducer,
  patientlist: patientReducer,
  feeslist: feesReducer,
  user: usersReducer,
  cart: productReducer,
  wallet: walletReducer,
});

export { rootReducers };
